module.exports = "<a class=anchor :class=\"{watching: isWatching}\" @click.prevent=onClick><span><slot></slot></span></a>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anchor.vue
 ** module id = 214
 ** module chunks = 0
 **/